export { Partners } from "./Partners"
export type { PartnersProps } from "./Partners"
